
import styled from "styled-components";

export const PageContainer = styled.div`&&{}`;

export const TitleBar = styled.div`&& {
    font-size: 24px;
    marign-top: 25px;
    margin-bottom: 30px;
  }`;

